import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Palette, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import ImageStyleOptions, { DEFAULT_IMG_STYLE, IMG_STYLES, fetchBrandStyle, saveBrandStyle, saveImgStyle } from "@/components/composer/ImageStyleOptions";
import { errMsg } from "@/lib/api";

// Tetapan: gaya design & warna jenama untuk gambar AI, disimpan di server.
export default function BrandStyleSection() {
  const [value, setValue] = useState(null);
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetchBrandStyle().then((d) => { setValue({ ...DEFAULT_IMG_STYLE, ...d, colors: d.colors?.length ? d.colors : DEFAULT_IMG_STYLE.colors }); setSaved(d.saved); })
      .catch(() => setValue(DEFAULT_IMG_STYLE));
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      await saveBrandStyle(value);
      saveImgStyle(value);
      setSaved(true);
      toast.success("Gaya jenama disimpan - semua peranti akan guna gaya ini");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  const label = IMG_STYLES.find((s) => s.v === value?.style)?.l;
  return (
    <section className="panel fade-up p-6" data-testid="settings-brand-style-section">
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-500/15 text-violet-300"><Palette className="h-4 w-4" /></div>
        <div>
          <h2 className="font-bold">Gaya Jenama (gambar AI)</h2>
          <p className="mt-1 text-sm text-muted-foreground">Gaya design & warna jenama kegemaran anda. Tulis Post di mana-mana peranti akan guna gaya ini secara automatik.</p>
        </div>
      </div>
      {!value ? <Loader2 className="mt-6 h-5 w-5 animate-spin text-primary" /> : (
        <div className="mt-6 space-y-4">
          <ImageStyleOptions value={value} onChange={setValue} />
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="text-xs text-muted-foreground" data-testid="settings-brand-style-status">
              {saved ? "Tersimpan" : "Belum disimpan"} · Gaya: <b className="text-slate-200">{label}</b>
            </p>
            <Button onClick={save} disabled={busy} data-testid="settings-brand-style-save-btn">
              {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Save className="mr-2 h-4 w-4" />} Simpan gaya jenama
            </Button>
          </div>
        </div>
      )}
    </section>
  );
}
